// extracted by mini-css-extract-plugin
export default {"fullPage":"FullPageSpinner_fullPage__pNT6e","error":"FullPageSpinner_error__aZTZj","icon":"FullPageSpinner_icon__+d-zz","buttons":"FullPageSpinner_buttons__MiiKM"};